/**
 * DAB-892: the api answers an expired, invalid or missing session with 401.
 * Installed once on the default axios instance, which ApiService and the
 * pages that call axios directly all share, so a stale session sends the
 * admin to /login instead of failing on whatever screen they were on.
 *
 * Skipped on purpose:
 * - the login request itself, so a wrong password still surfaces its own
 *   error on the login form instead of bouncing away from it.
 * - when already on /login, so this can't loop.
 */
const LOGIN_PATH = "/login";
const LOGIN_ENDPOINT = "/api/v1/admins/login";

const isLoginRequest = (config) => {
  const url = config?.url || "";
  return url.includes(LOGIN_ENDPOINT);
};

const isOnLoginPage = () =>
  typeof window !== "undefined" &&
  window.location?.pathname === LOGIN_PATH;

export const handleUnauthorized = (error) => {
  if (error?.response?.status !== 401) return;
  if (isLoginRequest(error?.config)) return;
  if (isOnLoginPage()) return;

  // Same steps as the logout saga. The full page load resets redux state.
  localStorage.removeItem("authUser");
  localStorage.removeItem("token");
  window.location.assign(LOGIN_PATH);
};

export const installUnauthorizedInterceptor = (axiosInstance) =>
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      handleUnauthorized(error);
      return Promise.reject(error);
    },
  );

export default handleUnauthorized;
